module.exports = __webpack_public_path__ + "images/emoji/ice_cream.30ff3bace38ab82eed5a.png";